import React from "react";
import PropTypes from "prop-types";
import InputStyles from "./messagesInput.module.css";

const MessagesInput = ({ onChange, onClick, value, disabled }) => {
  return (
    <form className={InputStyles.container}>
      <input
        className={InputStyles.field}
        value={value}
        onChange={onChange}
        disabled={disabled}
        type="text"
      ></input>
      <button
        className={InputStyles.button}
        onClick={onClick}
        disabled={disabled}
      >
        Send
      </button>
    </form>
  );
};

MessagesInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default MessagesInput;
